import { useState, useRef } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ImageUpload({ value, onChange, label = "Photo", testid }) {
  const [uploading, setUploading] = useState(false);
  const ref = useRef(null);

  const pick = () => ref.current?.click();

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Please choose an image file.");
    if (file.size > 5 * 1024 * 1024) return toast.error("Max size is 5MB.");
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/uploads/image", form, { headers: { "Content-Type": "multipart/form-data" } });
      const absolute = data.url.startsWith("http") ? data.url : `${BACKEND_URL}${data.url}`;
      onChange(absolute);
      toast.success("Uploaded.");
    } catch (err) {
      toast.error("Upload failed.");
    }
    setUploading(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div>
      <label className="label-tag" style={{ color: "#000" }}>{label}</label>
      <div className="mt-2 flex items-start gap-3">
        {value ? (
          <div className="relative">
            <img src={value} alt="preview" className="w-20 h-20 object-cover object-top border border-black/10"/>
            <button type="button" onClick={()=>onChange("")} className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 flex items-center justify-center" data-testid={`${testid}-clear`}><X size={12}/></button>
          </div>
        ) : (
          <div className="w-20 h-20 bg-neutral-100 border border-dashed border-black/20 flex items-center justify-center text-neutral-400 text-xs">No photo</div>
        )}
        <div className="flex-1">
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testid}-input`}/>
          <button type="button" onClick={pick} disabled={uploading} className="btn-ghost-dark !py-2 !px-4 text-sm" data-testid={`${testid}-btn`}>
            <Upload size={14}/> {uploading ? "Uploading…" : (value ? "Replace" : "Upload")}
          </button>
          <div className="mt-2 text-[10px] text-neutral-500 font-mono">JPG / PNG / WEBP · max 5MB</div>
          {value && <div className="mt-1 text-[10px] text-neutral-400 break-all">{value.length > 60 ? value.slice(0,60) + "…" : value}</div>}
        </div>
      </div>
    </div>
  );
}
